import { Grid, Typography, Button, InputBase } from "@material-ui/core";
import { useEffect, useState } from "react";
import logo from "../../assets/stoqqyLogo.svg";
import submit from "../../assets/submit.svg";
import tick from "../../assets/tick.svg";
import { Link } from "react-router-dom";
import { Alert } from "@material-ui/lab";
import axios from "axios";
import { useHistory } from "react-router";
import { url, auth_key, user_id } from "../../constants";
import { useSelector } from "react-redux";
import { withNamespaces } from "react-i18next";

const sendEmail = async (message) => {
  try {
    const response = await axios.post(
      `${url}/feedbackemail`,
      {
        message: message,
      },
      {
        headers: {
          "X-Api-Key": auth_key,
        },
        params: {
          User_ID: user_id,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

const Contact = ({ t }) => {
  const isDesktopOrLaptop = useSelector((state) => state.screenSize.value);
  const states = useSelector((state) => state.states.value);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState(null);
  const history = useHistory();

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Contact Stoqqy";
  }, []);

  return (
    <>
      <Grid
        container
        style={{
          backgroundColor: "#f8f8f8",
          height: isDesktopOrLaptop ? "85px" : "55px",
          padding: isDesktopOrLaptop
            ? "35px 0px 35px 98px"
            : "14px 15px 15px 11px",
        }}
      >
        <Link to="/home">
          <img
            src={logo}
            alt="logo"
            width={isDesktopOrLaptop ? "151px" : "100px"}
          />
        </Link>
      </Grid>

      <Typography
        style={{
          fontFamily: "Overpass",
          fontSize: isDesktopOrLaptop ? "16px" : "14px",
          fontWeight: "bold",
          color: "#16063b",
          cursor: "pointer",
          marginTop: isDesktopOrLaptop ? "35px" : "25px",
          marginLeft: isDesktopOrLaptop ? "98px" : "12px",
        }}
        onClick={() => {
          history.goBack();
        }}
      >
        {`< ${t("back")}`}
      </Typography>

      <div
        style={{
          minHeight: "77vh",
          width: "100%",
          marginBottom: isDesktopOrLaptop ? "35px" : "30px",
        }}
      >
        {alertMessage ? (
          alertMessage !== "sent" ? (
            // <Alert
            //   severity="success"
            //   style={{ position: "fixed", top: 0, zIndex: 5, width: "100%" }}
            // >
            //   We have received your feedback. We shall get back to you soon.
            // </Alert>
            // ) : (
            <Alert
              severity="error"
              style={{ position: "fixed", top: 0, zIndex: 5, width: "100%" }}
            >
              {t("contact_error")}
            </Alert>
          ) : null
        ) : null}

        <div style={{ display: "flex", justifyContent: "center" }}>
          <Grid
            item
            xs={isDesktopOrLaptop ? 8 : 12}
            style={{
              backgroundColor: "white",
              height: "100%",
              padding: isDesktopOrLaptop ? "40px 0px" : "25px 17px 0px 12px",
            }}
          >
            {alertMessage !== "sent" ? (
              <>
                <Grid container>
                  <Typography
                    style={{
                      color: "#16063b",
                      fontFamily: "Overpass",
                      fontSize: "32px",
                      fontWeight: "bold",
                    }}
                  >
                    {t("contact_us")}
                  </Typography>
                </Grid>
                <Grid container>
                  <Typography
                    style={{
                      color: "#808080",
                      fontFamily: "Overpass",
                      fontSize: "16px",
                      lineHeight: 1.5,
                    }}
                  >
                    {t("contact_tagline")}
                  </Typography>
                </Grid>
                <Grid
                  style={{
                    borderRadius: "15px",
                    boxShadow: "0 0 11px 0 #00000027",
                    backgroundColor: "#fff",
                    padding: "20px 20px 28px 20px",
                    marginTop: isDesktopOrLaptop ? "40px" : "30px",
                  }}
                >
                  <Grid container>
                    <Grid
                      item
                      xs={isDesktopOrLaptop ? 6 : 12}
                      style={{
                        paddingRight: isDesktopOrLaptop ? "10px" : "0px",
                      }}
                    >
                      <Typography
                        style={{
                          color: "#808080",
                          fontFamily: "Overpass",
                          fontSize: isDesktopOrLaptop ? "16px" : "14px",
                          paddingBottom: "10px",
                        }}
                      >
                        {t("name")}*
                      </Typography>
                      <div
                        style={{
                          border:
                            alertOpen && name === ""
                              ? "solid 1.5px #e50303"
                              : "solid 1.5px #808080",
                          borderRadius: "5px",
                          height: isDesktopOrLaptop ? "55px" : "37px",
                          display: "flex",
                          alignItems: "center",
                          paddingLeft: "10px",
                          paddingRight: "10px",
                        }}
                      >
                        <InputBase
                          value={name}
                          placeholder="es. Mario"
                          fullWidth
                          required
                          margin="normal"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          onChange={(e) => {
                            setName(e.target.value);
                          }}
                          style={{}}
                        />
                      </div>
                      {alertOpen && name === "" ? (
                        <Typography
                          style={{
                            color: "#e50303",
                            fontSize: "12px",
                            fontWeight: "Overpass",
                          }}
                        >
                          *{t("contact_warning")}
                        </Typography>
                      ) : null}
                    </Grid>
                    <Grid
                      item
                      xs={isDesktopOrLaptop ? 6 : 12}
                      style={{
                        paddingLeft: isDesktopOrLaptop ? "10px" : "0px",
                        paddingTop: isDesktopOrLaptop ? "0" : "20px",
                      }}
                    >
                      <Typography
                        style={{
                          color: "#808080",
                          fontFamily: "Overpass",
                          fontSize: isDesktopOrLaptop ? "16px" : "14px",
                          paddingBottom: "10px",
                        }}
                      >
                        Email*
                      </Typography>
                      <div
                        style={{
                          border:
                            alertOpen && email === ""
                              ? "solid 1.5px #e50303"
                              : "solid 1.5px #808080",
                          borderRadius: "5px",
                          height: isDesktopOrLaptop ? "55px" : "37px",
                          display: "flex",
                          alignItems: "center",
                          paddingLeft: "10px",
                          paddingRight: "10px",
                        }}
                      >
                        <InputBase
                          label="Email"
                          value={email}
                          placeholder="es. abcd@gmail.com"
                          fullWidth
                          margin="normal"
                          required
                          InputLabelProps={{
                            shrink: true,
                          }}
                          onChange={(e) => {
                            setEmail(e.target.value);
                          }}
                        />
                      </div>
                      {alertOpen && email === "" ? (
                        <Typography
                          style={{
                            color: "#e50303",
                            fontSize: "12px",
                            fontWeight: "Overpass",
                          }}
                        >
                          *{t("contact_warning")}
                        </Typography>
                      ) : null}
                    </Grid>
                  </Grid>
                  <Typography
                    style={{
                      color: "#808080",
                      fontFamily: "Overpass",
                      fontSize: isDesktopOrLaptop ? "16px" : "14px",
                      paddingBottom: "10px",
                      paddingTop: "20px",
                    }}
                  >
                    {t("subject")}*
                  </Typography>
                  <div
                    style={{
                      border:
                        alertOpen && subject === ""
                          ? "solid 1.5px #e50303"
                          : "solid 1.5px #808080",
                      borderRadius: "5px",
                      height: isDesktopOrLaptop ? "55px" : "37px",
                      display: "flex",
                      alignItems: "center",
                      paddingLeft: "10px",
                      paddingRight: "10px",
                    }}
                  >
                    <InputBase
                      label="Subject"
                      multiline
                      value={subject}
                      placeholder="es. Usability"
                      fullWidth
                      margin="normal"
                      required
                      InputLabelProps={{
                        shrink: true,
                      }}
                      onChange={(e) => {
                        setSubject(e.target.value);
                      }}
                    />
                  </div>
                  {alertOpen && subject === "" ? (
                    <Typography
                      style={{
                        color: "#e50303",
                        fontSize: "12px",
                        fontWeight: "Overpass",
                      }}
                    >
                      *{t("contact_warning")}
                    </Typography>
                  ) : null}
                  <Typography
                    style={{
                      color: "#808080",
                      fontFamily: "Overpass",
                      fontSize: isDesktopOrLaptop ? "16px" : "14px",
                      paddingBottom: "10px",
                      paddingTop: "20px",
                    }}
                  >
                    {t("message")}*
                  </Typography>
                  <div
                    style={{
                      border:
                        alertOpen && message === ""
                          ? "solid 1.5px #e50303"
                          : "solid 1.5px #808080",
                      borderRadius: "5px",
                      paddingLeft: "10px",
                      paddingRight: "10px",
                      height: isDesktopOrLaptop ? "220px" : "159px",
                    }}
                  >
                    <InputBase
                      label="Message"
                      multiline
                      value={message}
                      placeholder={t("message_placeholder")}
                      fullWidth
                      margin="normal"
                      required
                      InputLabelProps={{
                        shrink: true,
                      }}
                      onChange={(e) => {
                        setMessage(e.target.value);
                      }}
                    />
                  </div>
                  {alertOpen && message === "" ? (
                    <Typography
                      style={{
                        color: "#e50303",
                        fontSize: "12px",
                        fontWeight: "Overpass",
                      }}
                    >
                      *{t("contact_warning")}
                    </Typography>
                  ) : null}
                  <Grid
                    item
                    xs={12}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      paddingTop: "25px",
                    }}
                  >
                    <Button
                      variant="contained"
                      style={{
                        borderRadius: "22.5px",
                        backgroundColor: "#0040ff",
                        color: "#f8f8f8",
                        fontSize: "16px",
                        fontFamily: "Overpass",
                        textTransform: "capitalize",
                        display: "flex",
                        alignItems: "center",
                      }}
                      onClick={async () => {
                        if (
                          name === "" ||
                          email === "" ||
                          subject === "" ||
                          message === ""
                        ) {
                          setAlertOpen(true);
                        } else {
                          setAlertOpen(false);
                          var messageBody = JSON.stringify({
                            name: name,
                            email: email,
                            subject: subject,
                            message: message,
                          });

                          const response = await sendEmail(
                            messageBody?.substring(1, messageBody.length - 1)
                          );
                          setAlertMessage(
                            response === "sent" ? "sent" : "failed"
                          );
                          if (response === "sent") {
                            setName("");
                            setEmail("");
                            setSubject("");
                            setMessage("");
                          }
                        }
                      }}
                    >
                      {t("submit")}
                      <span style={{ marginLeft: "8px" }}>
                        <img src={submit}></img>
                      </span>
                    </Button>
                  </Grid>
                </Grid>
              </>
            ) : (
              <div
                style={{
                  width: isDesktopOrLaptop ? "100%" : "95%",
                  display: "flex",
                  justifyContent: "center",
                  margin: isDesktopOrLaptop ? "0" : "0 17px 0 14px",
                }}
              >
                <Grid
                  style={{
                    width: isDesktopOrLaptop ? "600px" : "100%",
                    height: isDesktopOrLaptop ? "450px" : "auto",
                    borderRadius: "15px",
                    boxShadow: "0 0 11px 0 #00000027",
                  }}
                >
                  <div
                    style={{
                      padding: isDesktopOrLaptop
                        ? "69px 61px 42px 62px"
                        : "40px 19px 41px 20px",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <img src={tick} alt={"tick"}></img>
                    </div>
                    <Typography
                      style={{
                        fontFamily: "Overpass",
                        fontSize: isDesktopOrLaptop ? "38px" : "32px",
                        fontweight: "bold",
                        textAlign: "center",
                        color: "#59e721",
                        marginTop: "25px",
                        height: isDesktopOrLaptop ? "48px" : "40px",
                      }}
                    >
                      {t("thank_you")}
                    </Typography>
                    <Typography
                      style={{
                        fontFamily: "Overpass",
                        fontSize: "16px",
                        lineHeight: 1.63,
                        textAlign: "center",
                        color: "#808080",
                        height: isDesktopOrLaptop ? "88px" : "",
                        marginTop: isDesktopOrLaptop ? "25px" : "20px",
                        marginBottom: isDesktopOrLaptop ? "60px" : "44px",
                      }}
                    >
                      {t("contact_submit")}
                    </Typography>
                    <Link to="/home">
                      <Typography
                        style={{
                          height: "21px",
                          fontFamily: "Overpass",
                          fontSize: "16px",
                          fontWeight: "bold",
                          textAlign: "center",
                          color: "#0040ff",
                          cursor: "pointer",
                        }}
                      >
                        {t("back_to_home")}
                      </Typography>
                    </Link>
                  </div>
                </Grid>
              </div>
            )}
          </Grid>
        </div>
      </div>
    </>
  );
};
export default withNamespaces()(Contact);
